import React from 'react';
import SecondImage from "../assets/PagingDrVedoPortfolioCover.jpg";

function About() {
  return (
    <section>
      <div className="mx-auto w-full">
        <div className="grid gap-6 sm:gap-6 md:grid-cols-2 ">
          {/* Left Column (Text and Buttons) */}
          <div className="flex flex-col items-start gap-2 md:py-14 md:px-14 max-w-[650px] p-4">
            <div className="flex items-center rounded-md py-1">
              <p className="text-md uppercase mb-6">Pretty Websites Don’t Pay the Bills.</p>
            </div>
            <h4 className="mb-2 text-3xl font-medium text-[#CFF098] md:text-5xl md:mb-2 font-storia">
           Imagine a platform that books your calls, delivers your content, and wows your clients — all in one place.
            </h4>
             <h4 className="mb-6 text-[16px] font-semibold md:text-[20px] md:mb-4 uppercase">
             Your site shouldn't just look good — it should work hard for you.
        
            </h4>
            <p className="text-sm sm:text-xl">
           If you're stuck with a pretty brochure site that doesn’t do much, it’s time to upgrade. You deserve a digital space that grows with your business.
            </p>
            <div className="flex flex-col gap-4 font-regular sm:flex-row py-4">
              <a href="/services" className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-4 text-black hover:opacity-60  text-sm">
                <p className='uppercase'> DISCOVER YOUR PLATFORM POTENTIAL →</p>
              </a>
            </div>
          </div>

          {/* Right Column (Image) */}
          <div className="relative w-full">
          <a href='https://tierag19.sg-host.com'>
            <img
              src={SecondImage}
              alt="women using a laptop outdoors - Woaom Web Design"
              className="absolute top-0 right-0 w-auto h-full object-cover"
            />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;